module.exports = __webpack_public_path__ + "5e86dabe7a3ee6d78a3b558904a13271.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/modals/confirm-delete/confirm-delete.html
// module id = 1072
// module chunks = 0